function n(n,e,o,t){n._m(e);var r=o("1e4c53f3");n._(e,"InventoryWMS",r),n._(e,"inventoryRoute",r);}